import BaseUser from "@/models/SvcModels/User";

export default class User extends BaseUser {
  static entity = "users";
  static primaryKey = "uuid";

  static fields() {
    return {
      ...super.fields(),
    };
  }

  get isExternal() {
    return this.groups.includes("ExternalUser");
  }
}
